const Accordion2 = (() => {

    const SELECTOR_MODULE = '[data-accordion]';
    const SELECTOR_BUTTON_OPEN = '.btn-open-item';

    const initialize = () => {

        const modules = document.querySelectorAll(SELECTOR_MODULE);

        if (!modules?.length) return;

        modules.forEach((accordion) => {

            accordion.addEventListener('click', e => {
                const item = e.target.closest('.accordion__item');
                if (!item) return;

                accordion
                    .querySelectorAll('.accordion__item')
                    .forEach(el => el.classList.remove('active'));

                item.classList.add('active');
            });



        });


    };

    return {
        initialize
    }

})();

export default Accordion2;

